<template>
  <div>
    <base-modal
      size="max-w-6xl"
      :showing="visible && !productBoxModalVisible"
      @close="onClose"
      @opened="onOpened"
    >
      <base-card
        title="Detail Barang"
        description="Berdasarkan data barang yang telah dibuat"
        :with-style="false"
      >
        <div class="border-t pt-5">
          <dl :class="['grid grid-cols-1 gap-x-4 gap-y-8 sm:pb-6', col === 3 ? 'sm:grid-cols-6' : 'sm:grid-cols-8']">
            <div v-if="detailColumns.includes('is_published')" class="sm:col-span-6">
              <dt class="text-sm font-bold text-gray-700">Status Publish</dt>
              <dd class="mt-1 text-sm text-gray-900">
                <base-toggle
                  with-label
                  label-true="Publish"
                  label-false="Tidak Terpublish"
                  v-model="product.data.attributes.is_published"
                  @change-debounce="onChangePublishedDebounce"
                />
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Kode Barang</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.code }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Nama Barang</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.name }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('volume')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Isi</dt>
              <dd class="mt-1 text-sm text-gray-900">
                <p v-if="!product.data.attributes.volume">-</p>
                <p v-else>
                  {{ product.data.attributes.volume }}
                  {{ product.data.attributes.unit_name }}
                </p>
              </dd>
            </div>
            <div v-if="detailColumns.includes('category')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Kategori Barang</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.product_category_name ?? '-' }}
              </dd>
            </div>
            <template v-if="detailColumns.includes('complete_volume')">
              <div class="sm:col-span-2">
                <dt class="text-sm font-bold text-gray-700">Volume</dt>
                <dd class="mt-1 text-sm text-gray-900">
                  {{ product.data.attributes.volume ?? '-' }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="text-sm font-bold text-gray-700">Satuan Volume</dt>
                <dd class="mt-1 text-sm text-gray-900">
                  {{ product.data.attributes.unit_name ?? '-' }}
                </dd>
              </div>
              <div class="sm:col-span-2">
                <dt class="text-sm font-bold text-gray-700">Satuan Unit</dt>
                <dd class="mt-1 text-sm text-gray-900">
                  {{ product.data.attributes.unit_2_name ?? '-' }}
                </dd>
              </div>
            </template>
            <div v-if="detailColumns.includes('supplier')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Kode Supplier</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.supplier_code ?? '-' }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('is_published')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Nama Supplier</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.supplier_name ?? '-' }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('is_published')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Harga Supplier</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.supplier_price | toCurrency }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">P/N</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.is_point ? 'Point' : 'Non Point' }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('point')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">PV</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.point | toCurrency }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('bonus')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">BV</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.bonus | toCurrency }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('license')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Lembaga Ijin</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.license_institution || '-' }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('license')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Status Izin</dt>
              <dd class="mt-1 text-sm text-gray-900">
                <base-badge
                  :color="
                    product.data.attributes.license_status ? 'green' : 'red'
                  "
                  >{{
                    product.data.attributes.license_status
                      ? 'Lengkap'
                      : 'Sedang Diproses'
                  }}</base-badge
                >
              </dd>
            </div>
            <div v-if="detailColumns.includes('license')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">
                Mulai Izin - Akhir Izin
              </dt>
              <dd class="mt-1 flex gap-1 text-sm text-gray-900">
                {{ product.data.attributes.license_start }}
                <span class="font-light text-gray-300">s.d</span>
                {{ product.data.attributes.license_end }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('timestamp')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Dibuat</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.createdAt | formatDate }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('timestamp')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">
                Terakhir Diperbarui
              </dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.updatedAt | formatDate }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('stock_qty')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Saldo Awal</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.stock_qty ?? '-' }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('stock_min_qty')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Saldo Minimal di Gudang</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product.data.attributes.stock_min_qty ?? '-' }}
              </dd>
            </div>
            <div v-if="detailColumns.includes('qr')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">QR</dt>
              <dd class="mt-1 space-y-2 text-sm text-gray-900">
                <base-toggle
                  with-label
                  label-true="Pindai Aktif"
                  label-false="Pindai Tidak Aktif"
                  v-model="product.data.attributes.is_qrcode_active"
                  @change-debounce="onUpdateQrCodeActive"
                />
                <base-toggle
                  v-if="product.data.attributes.is_qrcode_active"
                  with-label
                  label-true="Unique QR Aktif"
                  label-false="Single QR Aktif"
                  v-model="product.data.attributes.is_unique_qrcode_active"
                  @change-debounce="onUpdateUniqueQrCodeActive"
                />
                <div
                  :class="{
                    'grid grid-cols-2 gap-2':
                      product.data.attributes.qrcode ||
                      product.data.attributes.has_boxes,
                  }"
                >
                  <span v-if="product.data.attributes.qrcode">QR Piece</span>
                  <a
                    v-else
                    href=""
                    class="mr-4 font-medium text-green-600 hover:text-green-500"
                    @click.prevent="onSetupQr"
                    >Setup QR</a
                  >
                  <a
                    href=""
                    class="font-medium text-yellow-600 hover:text-yellow-500"
                    @click.prevent="onSetupQrBox"
                    >{{
                      product.data.attributes.has_boxes
                        ? 'Daftar QR Box'
                        : 'Setup QR Box'
                    }}</a
                  >
                  <div>
                    <qr-code
                      v-if="product.data.attributes.qrcode"
                      :text="product.data.attributes.qrcode"
                      :size="100"
                    />
                  </div>
                  <ul class="list-inside list-disc">
                    <li
                      v-for="name in productBoxesName"
                      :key="name"
                      class="text-sm"
                    >
                      {{ name }}
                    </li>
                  </ul>
                </div>
              </dd>
            </div>

            <datatable
              class="col-span-full"
              :columns="[
                { id: 'area', name: 'Area' },
                {
                  id: 'stockist_price',
                  name: 'Harga Stockist',
                  theadClass: 'text-right',
                },
                {
                  id: 'member_price',
                  name: 'Harga Mitra Usaha',
                  theadClass: 'text-right',
                },
                {
                  id: 'consument_price',
                  name: 'Harga Konsumen',
                  theadClass: 'text-right',
                },
              ]"
            >
              <template #tbody="{ classes }">
                <tr
                  v-for="(price, index) in productPrices"
                  :key="index"
                  :class="classes.tr"
                >
                  <td :class="[classes.td]">
                    <p class="font-medium text-gray-900">{{ price.area }}</p>
                  </td>
                  <td :class="[classes.td, 'text-right']">
                    {{ price.stockist_price | toCurrency }}
                  </td>
                  <td :class="[classes.td, 'text-right']">
                    {{ price.member_price | toCurrency }}
                  </td>
                  <td :class="[classes.td, 'text-right']">
                    {{ price.consument_price | toCurrency }}
                  </td>
                </tr>
              </template>
            </datatable>

            <template v-if="detailColumns.includes('additional_price')">
              <div class="rounded-lg border p-4 sm:col-span-2">
                <dt class="text-sm font-bold text-gray-700">Harga Karyawan</dt>
                <dd class="mt-1 text-sm text-gray-900">
                  {{ getProductPrice('Wilayah Jawa', 'Karyawan') | toCurrency }}
                </dd>
              </div>
              <div class="rounded-lg border p-4 sm:col-span-2">
                <dt class="text-sm font-bold text-gray-700">Harga Khusus</dt>
                <dd class="mt-1 text-sm text-gray-900">
                  {{ getProductPrice('Wilayah Jawa', 'Khusus') | toCurrency }}
                </dd>
              </div>
              <div class="rounded-lg border p-4 sm:col-span-2">
                <dt class="text-sm font-bold text-gray-700">Harga Free</dt>
                <dd class="mt-1 text-sm text-gray-900">
                  {{ getProductPrice('Wilayah Jawa', 'Free') | toCurrency }}
                </dd>
              </div>
            </template>
          </dl>

          <div class="flex justify-end">
            <base-button @click="$emit('close')">Tutup</base-button>
          </div>
        </div>
      </base-card>
    </base-modal>
    <view-product-box-modal
      :product-id="product.data.id"
      :product-code="product.data.attributes.code"
      :visible="productBoxModalVisible"
      @close="productBoxModalVisible = false"
      @created="reload = true"
    />
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import ViewProductBoxModal from './view-product-box-modal.vue';
import QrCode from 'vue-qrcode-component';
import { requestMixin } from '@/mixins/request/request';
import BaseToggle from '@/components/base/BaseToggle.vue';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
    QrCode,
    BaseToggle,
    ViewProductBoxModal,
  },
  props: {
    visible: Boolean,
    productId: String,
    detailColumns: {
      type: Array,
      default: () => ['is_published', 'category', 'supplier', 'pv', 'bv', 'license', 'timestamp', 'qr', 'additional_price']
    },
    col: {
      type: Number,
      default: 3
    }
  },
  emits: ['close'],
  data() {
    return {
      loadingProduct: false,
      loadingSetupQr: false,
      loadingUpdateQrCodeActive: false,
      loadingUpdateUniqueQrCodeActive: false,
      loadingUpdatePublished: false,
      product: {
        data: {
          attributes: {
            code: null,
          },
        },
        included: [],
      },
      productBoxesName: [],
      productBoxModalVisible: false,
      reload: true,
    };
  },
  computed: {
    loading() {
      return (
        this.loadingProduct ||
        this.loadingSetupQr ||
        this.loadingUpdateQrCodeActive ||
        this.loadingUpdateUniqueQrCodeActive ||
        this.loadingUpdatePublished
      );
    },
    productPrices() {
      return [
        'Wilayah Jawa',
        'Wilayah I',
        'Wilayah II',
        'Wilayah III',
        'Wilayah IV',
      ].map((area) => ({
        area,
        stockist_price: this.getProductPrice(area, 'Stockist'),
        member_price: this.getProductPrice(area, 'Mitra Usaha'),
        consument_price: this.getProductPrice(area, 'Konsumen'),
      }));
    },
  },
  methods: {
    getProductPrice(area, buyerType) {
      const productPrice = this.product.included.find(
        (included) =>
          included.type === 'product-prices' &&
          included.attributes.area === area &&
          included.attributes['buyer-type'] === buyerType
      );

      if (!productPrice) {
        return null;
      }

      return productPrice.attributes.price;
    },
    async loadProduxtBoxes() {
      const [res, err] = await this.request(
        `/api/v1/products/${this.productId}/product-boxes`,
        {
          params: {
            'page[size]': 5,
            'fields[products]': 'name',
            sort: '-createdAt',
          },
        }
      );

      if (!err) {
        this.productBoxesName = res.data.map((item) => item.attributes.name);
      }
    },
    async onOpened() {
      if (this.reload) {
        this.loadingProduct = true;

        const [res, err] = await this.request(
          `/api/v1/products/${this.productId}`,
          {
            params: {
              'fields[products]':
                'volume,unit_name,unit_2_name,is_published,code,name,product_category_name,supplier_code,supplier_name,supplier_price,is_point,point,bonus,license_institution,license_status,license_start,license_end,createdAt,updatedAt,qrcode,product-prices,is_qrcode_active,is_unique_qrcode_active,has_boxes',
              include: 'product-prices',
            },
          }
        );

        if (!err) {
          this.product = res;

          if (this.product.data.attributes.has_boxes) {
            await this.loadProduxtBoxes();
          } else {
            this.productBoxesName = [];
          }
        }

        this.loadingProduct = false;
      }
    },
    onClose() {
      this.reload = true;
      this.$emit('close');
    },
    async onSetupQr() {
      this.loadingSetupQr = true;

      const [, err] = await this.request(`/api/v1/products/${this.productId}`, {
        method: 'patch',
        data: {
          data: {
            id: this.productId,
            type: 'products',
            attributes: {
              qrcode: `${this.product.data.attributes.code}-1`,
            },
          },
        },
      });

      if (!err) {
        this.onOpened();
      }

      this.loadingSetupQr = false;
    },
    onSetupQrBox() {
      this.productBoxModalVisible = true;
      this.reload = false;
    },
    async onUpdateQrCodeActive() {
      this.loadingUpdateQrCodeActive = true;

      await this.request(`/api/v1/products/${this.productId}`, {
        method: 'patch',
        data: {
          data: {
            id: this.productId,
            type: 'products',
            attributes: {
              is_qrcode_active: this.product.data.attributes.is_qrcode_active,
            },
          },
        },
      });

      this.loadingUpdateQrCodeActive = false;
    },
    async onUpdateUniqueQrCodeActive() {
      this.loadingUpdateUniqueQrCodeActive = true;

      await this.request(`/api/v1/products/${this.productId}`, {
        method: 'patch',
        data: {
          data: {
            id: this.productId,
            type: 'products',
            attributes: {
              is_unique_qrcode_active:
                this.product.data.attributes.is_unique_qrcode_active,
            },
          },
        },
      });

      this.loadingUpdateUniqueQrCodeActive = false;
    },
    async onChangePublishedDebounce() {
      this.loadingUpdatePublished = true;

      await this.request(`/api/v1/products/${this.productId}`, {
        method: 'patch',
        data: {
          data: {
            id: this.productId,
            type: 'products',
            attributes: {
              is_published: this.product.data.attributes.is_published,
            },
          },
        },
      });

      this.loadingUpdatePublished = false;
    },
  },
};
</script>
